import { z } from 'zod';
import { FieldSchema } from '../common/field';
import { InitialUIElement } from '../initial-ui-element';
import { CommonOption } from '../common';

export const RADIO_FIELD_ELEMENT_TYPE = 'radiofield' as const;
export const RadioFieldElementType = z.literal(RADIO_FIELD_ELEMENT_TYPE);

export const RadioFieldParamsSchema = FieldSchema.extend({
  options: z.array(CommonOption),
});

export type TRadioFieldParams = z.infer<typeof RadioFieldParamsSchema>;

export const RadioFieldElementSchema = InitialUIElement.extend({
  element: RadioFieldElementType,
  params: RadioFieldParamsSchema,
});
